<script setup>
defineProps({
  nameList: {
    type: Array,
    required: true
  },
  prefName: {
    type: String,
    required: true
  }
})
const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
</script>

<template>
  <section class="golfList">
    <CommonSectionTitle :title="`${prefName}のゴルフ場一覧`" />
    <div class="block">
      <template
        v-for="item in nameList"
        :key="item.path"
      >
        <div class="card">
          <NuxtLink
            :to="`${isWebViewFlag ? `${runtimeConfig.app.baseURL}${item.path.replace(/^\//, '')}` : item.path}`"
            class="card__inner"
            :external="isWebViewFlag"
          >
            <p class="name">
              {{ item.name.replace(/[（/]旧.*$/, '') }}
            </p>
            <p class="address">
              {{ item.address }}
            </p>
          </NuxtLink>
        </div>
      </template>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.golfList {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .block {
    display: flex;
    flex: 1;
    flex-direction: column;
    max-height: 300px;
    border: 1px solid #ccc;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 100vmax;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background: #438fec;
    }
    .card {
      &:not(:last-child) {
        border-bottom: 1px solid #ccc;
      }
      .card__inner {
        display: flex;
        flex-direction: column;
        padding: 5px 10px;
        @media (any-hover: hover) {
          transition: opacity .2s ease-in-out;
          &:hover {
            opacity: .6;
          }
        }
        .name {
          font-size: 16px;
          font-weight: 600;
          color: #000000;
        }
        .address {
          font-size: 12px;
          color: #000000;
        }
      }
    }
  }
}
@media screen and (min-width: 830px) {
  .golfList {
    .block {
      max-height: 500px;
      .card {
        .card__inner {
          padding-right: 25px;
          background-image: url('https://gvs.weathernews.jp/golf/image/common/icon_arrow_blue.svg');
          background-position: right 4px center;
          background-repeat: no-repeat;
          background-size: 15px;
          .name {
            font-size: 18px;
          }
          .address {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
